import { useMemo } from 'react';
import * as THREE from 'three';
import type { TruckTextures } from './textures';
import { useConfig } from '../../store';
import { barZ } from './layout';

const SIDES = [1, -1] as const;

/** Side sign board, door roundels, and rear roundel. Toggled by the signage control. */
export function Decals({ tex }: { tex: TruckTextures }) {
  const showSignage = useConfig((s) => s.showSignage);

  const signMat = useMemo(
    () => new THREE.MeshStandardMaterial({ map: tex.sideSign, transparent: true, alphaTest: 0.02, roughness: 0.5, polygonOffset: true, polygonOffsetFactor: -1, polygonOffsetUnits: -1 }),
    [tex.sideSign],
  );
  const roundelMat = useMemo(
    () => new THREE.MeshBasicMaterial({ map: tex.roundel, transparent: true, alphaTest: 0.02, depthWrite: false, toneMapped: false, polygonOffset: true, polygonOffsetFactor: -1, polygonOffsetUnits: -1 }),
    [tex.roundel],
  );
  const counterLogoMat = useMemo(
    () => new THREE.MeshStandardMaterial({ map: tex.logoTex, transparent: true, alphaTest: 0.02, roughness: 0.5, polygonOffset: true, polygonOffsetFactor: -1, polygonOffsetUnits: -1 }),
    [tex.logoTex],
  );

  return (
    <group>
      {/* Door roundels — always on (branding), independent of the sign board */}
      {SIDES.map((s) => (
        <mesh key={s} position={[0.55, 0.8, s * 0.614]} rotation={[0, s < 0 ? Math.PI : 0, 0]} material={roundelMat} renderOrder={3}>
          <circleGeometry args={[0.155, 48]} />
        </mesh>
      ))}

      {showSignage && (
        <group>
          <mesh position={[-0.8, 0.68, barZ + 0.332]} material={counterLogoMat} renderOrder={2}>
            <planeGeometry args={[0.24 * tex.logoAspect, 0.24]} />
          </mesh>
          {/* Side sign board on the closed (-z) flank */}
          <mesh position={[-0.8, 1.16, -0.678]} rotation={[0, Math.PI, 0]} material={signMat} renderOrder={2}>
            <planeGeometry args={[1.5, 1.0]} />
          </mesh>
          {/* Rear roundel */}
          <mesh position={[-1.688, 1.28, 0]} rotation={[0, -Math.PI / 2, 0]} material={roundelMat} renderOrder={3}>
            <circleGeometry args={[0.185, 48]} />
          </mesh>
        </group>
      )}
    </group>
  );
}
